define('views/modules/calendar/animated-session/exercise/weight/weight-week',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/weight-set',
], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // views
    VWeightExerciseSet
) {

    var VWeightExerciseWeek = Backbone.View.extend({
        exerciseSetView: VWeightExerciseSet,
        tagName: "tbody",
        regions: {
            index: '.num-col',
            sets: 'input[name="sets"]',
        },
        initialize: function(opt) {
            this.options = opt || {};

            var model = this.model,
                collection = this.collection = model.getSets();

            this.listenTo(model, {
                "remove": this.remove,
            });

            this.listenTo(collection, {
                "update": this.onSetsUpdate,
                "reset": this.resetList,
                "change": this.onSetsChange
            });

            this.listenTo(model, { 'change:numSets': this.onSetsChange });

        },
        render: function() {
            this.resetList();
            this.generateZones();
            return this;
        },

        addAll: function(models, displayWarningIcon) {
            if (_.isUndefined(displayWarningIcon) || _.isNull(displayWarningIcon)) {
                displayWarningIcon = false;
            }
            var first = false;
            if (_.isUndefined(models) || _.isNull(models)) {
                first = true;
                models = this.collection.toArray();
            }

            var container = document.createDocumentFragment(),
                chunkSize = 4;

            _.each(models, function(model) {
                container.appendChild(this.addSet(model, first, false, displayWarningIcon));
                first = false;
            }, this);

            this.$el.append(container);

            // if (models.length > chunkSize) {
            //     var rest = _.rest(models, chunkSize);
            //     _.defer(this.addAll.bind(this), rest);
            // }
        },

        addSet: function(model, first, render, displayWarningIcon) {
            if (_.isUndefined(displayWarningIcon) || _.isNull(displayWarningIcon)) {
                displayWarningIcon = false;
            }

            var view = new this.exerciseSetView({
                model: model,
                week: this.model,
                first: first,
                setIndex: this.collection.indexOf(model) + 1,
                index: this.options.index,
                warningIcon: displayWarningIcon
            });
            this.childViews.push(view);
            view.render();

            // early return the content
            if (render !== false) {
                // render now
                this.$el.append(view.el);
            }

            return view.el;
        },

        resetList: function() {
            // render the table header
            this.$el.empty();
            this.removeChildViews({ defer: true });
            this.addAll();
            // _.defer(this.addAll.bind(this));
        },

        ////////////
        // events //
        ////////////

        onSetsUpdate: function(collection, options) {
            if (options.changes.added) {
                this.addAll(options.changes.added);
                // _.defer(this.addAll.bind(this), options.changes.added);
            }
        },

        onSetsChange: function() {
            this.model.trigger('change:sets');
        },

    });

    return VWeightExerciseWeek;

});

